export const calculateTableHeight = (offset = 350) => {
  return window.innerHeight - offset;
};
